/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Include_AgencyInputs */

const cs_builder_prop_include_agency = /** @type {(inputs: Builder_Prop_Include_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahrnout agenturu`)
};

const en_builder_prop_include_agency = /** @type {(inputs: Builder_Prop_Include_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include agency`)
};

/**
* | output |
* | --- |
* | "Include agency" |
*
* @param {Builder_Prop_Include_AgencyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_include_agency = /** @type {((inputs?: Builder_Prop_Include_AgencyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Include_AgencyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_include_agency(inputs)
	return cs_builder_prop_include_agency(inputs)
});